import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwHomeComponent } from './pw-home.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { PwHomeRoutingModule } from './pw-home-routing.module';
import { PwSubmitPopupModule } from '../pw-submit-popup/pw-submit-popup.module';
import { PwThanksPageModule } from '../pw-thanks-page/pw-thanks-page.module';

@NgModule({
  declarations: [
    PwHomeComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    CustomInputModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    PwHomeRoutingModule,
    PwSubmitPopupModule,
    PwThanksPageModule
  ]
})
export class PwHomeModule { }
